import {ClientConsentModel} from './consent.model';
import {SaveClientModel} from './save-client.model';

export class SaveClientResponseModel extends SaveClientModel {


  public consents: ClientConsentModel[] = [];

}
